export default __webpack_public_path__ + "static/media/pi-photo.4d04311f.jpeg";